exports.default = {
  'membership_promotion': '会员推广计划',
  'page_under_development': '页面正在紧锣密鼓开发中，敬请期待！'
}
